import PropTypes from 'prop-types'
import React from 'react'
import { ThemeContext } from 'styled-components'

import HowToBlock from 'components/_special/HowToBlock'
import RenderInView from 'components/RenderInView'
import { Text } from 'styles/components/typography'

import tubeLine from './assets/tube-line.svg'
import {
  Wrapper,
  LineImg,
  SectionWrapperStyled,
  DynamicImageStyled,
  Highlight,
} from './styles'

/**
 * DHowRegister
 *
 * @param {object} props - properties of component
 * @returns {node} DHowRegister
 */
const WHowRegister = ({ data, index, isSquareHidden, pathCdn }) => {
  const { colors } = React.useContext(ThemeContext)

  return (
    <SectionWrapperStyled isOverflowHidden={true} classNameInner="pb-4">
      <HowToBlock
        isSquareHidden={isSquareHidden}
        title={data.title}
        index={index}
        squareColor={colors.cerulean}
        lineColor="light"
        textColor="light"
      >
        <div className="row">
          <div className="col-12 col-md-6 col-lg-5 offset-md-1 pb-2 pb-md-0">
            <Text
              className="text--white with-inverted-links"
              dangerouslySetInnerHTML={{ __html: data.content }}
            />
          </div>
          <Wrapper className="col-12 col-md-5 col-lg-6">
            <RenderInView>
              <DynamicImageStyled
                alt="wgs-tube"
                image={`${pathCdn}/register/tube`}
                imageSizes={{ xs: 300, md: 350 }}
                imageType="png"
                fitOption="contain"
                namesByBreakpoints
              />
            </RenderInView>
            <LineImg alt="" src={tubeLine} />
            <Highlight />
          </Wrapper>
        </div>
      </HowToBlock>
    </SectionWrapperStyled>
  )
}

WHowRegister.propTypes = {
  data: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  pathCdn: PropTypes.string.isRequired,
  isSquareHidden: PropTypes.bool,
}

WHowRegister.defaultProps = {
  isSquareHidden: false,
}

export default WHowRegister
